import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import usePfqAxios from '../../hooks/usePfqAxios';
import Constants from '../../Constants';
import { getSafeRedirectUrl } from '../../utils/securityUtil';
import { getLocalStorageItem, removeLocalStorageItem } from '../../utils/localStorageUtil';

const callbackContainerClasses = "flex justify-center items-center h-screen";

const CaspeerAuthCallback = () => {
    const [verificationStatus, setVerificationStatus] = useState('Verifying code...');
    const location = useLocation();
    const { postData } = usePfqAxios()

    useEffect(() => {
        const verifyAuthCode = async () => {
            const params = new URLSearchParams(location.search);
            const code = params.get('code');

            // const fullPathWithQuery = window.location.pathname + window.location.search;
            // window.location.href = `http://localhost:3000${fullPathWithQuery}`;
            // return

            console.log('Authorization code:', code);

            if (!code) {
                console.error('No authorization code found in URL');
                setVerificationStatus('Error: No authorization code found');
                return;
            }

            const codeVerifier = getLocalStorageItem('casepeer_pkce_code_verifier');

            if (!codeVerifier) {
                console.error('No code verifier found in localStorage');
                setVerificationStatus('Error: Authentication flow is incomplete');
                return;
            }

            try {
                const response = await postData(Constants.ApiUrl.partner.casepeerCallbackVeify, {
                    code,
                    code_verifier: codeVerifier
                });

                console.log('Verification response:', response.data);

                if (response?.data?.verified) {
                    removeLocalStorageItem('casepeer_pkce_code_verifier');
                    setVerificationStatus('Code verified successfully');
                    console.log('Authentication successful!', response.data);

                    // Get stored redirect URL and validate it for security
                    const storedUrl = getLocalStorageItem('casepeer_redirect_url');
                    removeLocalStorageItem('casepeer_redirect_url');

                    // Only allow same-origin redirects to prevent open redirect attacks
                    const safeRedirectUrl = getSafeRedirectUrl(storedUrl, '/');
                    window.location.href = safeRedirectUrl;
                } else {
                    setVerificationStatus('Code verification failed');
                    console.error('Authentication failed:', response.data);
                }
            } catch (error) {
                console.error('Error verifying authorization code:', error);
                setVerificationStatus('Error verifying code');
            }

        };

        verifyAuthCode();
    }, [location, postData]);

    return (
        <div className={callbackContainerClasses}>
            <p>{verificationStatus}</p>
        </div>
    );
};

export default CaspeerAuthCallback;
